module.exports = __webpack_public_path__ + "img/database-dashboard.d48ad980.svg";